export default __webpack_public_path__ + "static/GIGERPEPECITY-2630d6b1ede6bda0ac17c37ce21a673e.jpg";